export default __webpack_public_path__ + "static/media/1photo(new).4e4ea053.jpg";